import { useTranslation } from "react-i18next";

const TableBody = ({ tableData, columns, currentPage, pageLimit }) => {
  const { t } = useTranslation();

  const TableWithData = () => {
    return (
      <tbody>
        {tableData
          .slice(
            (currentPage - 1) * pageLimit,
            (currentPage - 1) * pageLimit + pageLimit
          )
          .map((data, index) => {
            return (
              <tr key={data.id}>
                <td>{(currentPage - 1) * pageLimit + index + 1}</td>
                {columns.map(({ accessor }) => {
                  const tData = data[accessor] ? data[accessor] : "——";
                  return <td key={accessor}>{tData}</td>;
                })}
              </tr>
            );
          })}
      </tbody>
    );
  };

  const TableWithoutData = () => {
    return (
      <tbody>
        <tr>
          <td colSpan="10" style={{ textAlign: "center", height: 35 }}>
            {t("ad01242a61")}
          </td>
        </tr>
      </tbody>
    );
  };

  return <>{tableData.length > 0 ? <TableWithData /> : <TableWithoutData />}</>;
};

export default TableBody;
